import { useEffect, useRef } from "react";
import { BrowserQRCodeReader } from "@zxing/browser";

export const useQrCodeReader = ({
  scanDelay: delayBetweenScanAttempts,
  onResult,
  videoRef,
  streamRef,
}) => {
  const controlsRef = useRef(null);

  useEffect(() => {
    const codeReader = new BrowserQRCodeReader(null, {
      delayBetweenScanAttempts,
    });

    const stopReader = () => {
      controlsRef.current?.stop();
      BrowserQRCodeReader.cleanVideoSource(videoRef.current);
      BrowserQRCodeReader.releaseAllStreams();
    };

    if (!videoRef.current) {
      return;
    }

    if (!streamRef.current) {
      return;
    }

    codeReader
      .decodeFromStream(
        streamRef.current,
        videoRef.current,
        (result, error) => {
          onResult(result, error, codeReader);
        }
      )
      .then((controls) => {
        controlsRef.current = controls;
      })
      .catch((error) => {
        onResult(null, error, codeReader);
      });

    return () => {
      stopReader();
    };
  }, []);
};
